import { lazyWithRetry } from "@/react/lazyWithRetry";
import type { ClientActionDescriptor } from "@/managers/ClientActionRegistry";

// equipment.3d_viewer — first DOMAIN-tree glob-discovered client action +
// first adopter of the layout-XML DSL (`<ClientActionView>`) and the
// React-component-slot mount path. The matching `ir.action.client` row
// (`equipment.action_3d_viewer`) lives in
// `src/domains/logistics/equipment_operations/data/equipment_3d_action.xml`.
//
// Three.js + @react-three/fiber + @react-three/drei live behind a
// lazy boundary so the ~500KB 3D-scene bundle only loads when the
// dialog actually opens. First paint of the workspace is unaffected.

const Equipment3DPage = lazyWithRetry(
    () => import("../components/Equipment3DPage").then((m) => ({ default: m.Equipment3DPage })),
    "equipment.3d_viewer",
);

const plugin: ClientActionDescriptor = {
    key: "equipment.3d_viewer",
    component: Equipment3DPage,
    paramSchema: "uuid",
    layout: { modelKey: "logistics.equipment.type.master" },
};

export default plugin;
